// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2x0b7","controls":"styles_controls__Lft24","charLimit":"styles_charLimit__d9Q6p","input":"styles_input__2e97Z","send":"styles_send__5fjTt"};